import Vue from 'vue';
import _ from 'lodash';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('map-item', {
  template: require('./template.html'),
  name: 'map-item',
  components: {
    tooltip,
  },
  props: ['page', 'show-all'],
  methods: {
    warnDouble(page, pages) {
      let siblingUrls = _.filter(pages, o => !_.isEqual(o, page));
      siblingUrls = _.map(siblingUrls, 'url');
      const hasDuplicate = siblingUrls.includes(page.url);
      // we can't set a local "error" data prop because this function
      // is being used for rendering, and it is against vue practice
      // to set data in render functions or else it causes an infinite loop
      return hasDuplicate ? 'editorUi-duplicatePage-folder' : '';
    },
    cleanURL(url) {
      return url !== '/' ? `/${url}` : `${url}`;
    },
    toggleSubList() {
      const handle = this.$refs.dragHandle;
      const subList = handle.nextElementSibling;
      if (subList.style.display !== 'none') {
        subList.style.display = 'none';
      } else {
        subList.style.display = 'block';
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/site-map/map-item/index.js